module.exports = __webpack_public_path__ + "img/logo.62a5626e.png";